// import history from "history.js";
import axios from "axios";
import { get, post } from "../baseApi";
import { error, success } from "../../../views/utilities/Toast/Toast";
import { authHeaderWithToken, authHeaderWithOutToken } from "../AxiosHeader";
import UrlConfig from "./UrlConfig";

export const PDO_STAGE4_LOADING = "PDO_STAGE4_LOADING";
export const PDO_STAGE4_SUCCESS = "PDO_STAGE4_SUCCESS";
export const PDO_STAGE4_ERROR = "PDO_STAGE4_ERROR";

export const createOrUpdatePDOStage4 = (payload) => async (dispatch) => {
  let url = UrlConfig.CreateOrUpdatePDOStage4URL();

  dispatch({
    type: PDO_STAGE4_LOADING
  });

  let header = authHeaderWithToken();
  let res = await post(url, payload, header);
  if (res && res.status === 200) {
    //res && res.data
    success("PDO updated successfully...");
    dispatch({
      type: PDO_STAGE4_SUCCESS,
      //data: user//res.data
    });
    return true;
  } else if (res && res.isAxiosError) {
    if (res.response && res.response.data && res.response.data.message) {
      error(res.response.data.message);
    } else {
      error("Error while Submitting PDO...");
    }
    dispatch({
      type: PDO_STAGE4_ERROR
      //payload: res.isAxiosError
    });
    return false;
  }
};
